export function systemPages() {
    const viewport = {
        content: "width=device-width, initial-scale=1.0, user-scalable=no",
    };
    return {
        path: "/admin",
        name: "admin",
        component: () => import("@/views/admin/frame/home.vue"),
        meta: { title: "", viewport: viewport },
        children: [
            {
                path: "system",
                name: "system",
                component: () => import("@/views/admin/system/Home.vue"),
                meta: { title: "系统管理", viewport: viewport },
                children:[
                    {
                        path: "menu",
                        name: "menu",
                        component: () => import("@/views/admin/system/menu/Menu.vue"),
                        meta: { title: "菜单管理", viewport: viewport },
                    },
                ]
            },
        ]
    };
}